export const ValidatePassword = (password: string): boolean => {
    const minLength = 6;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /\d/.test(password);
    const hasNonAlphanumeric = /[\W_]/.test(password); // Matches any non-word character or underscore

    return password.length >= minLength && hasUpperCase && hasLowerCase && hasDigit && hasNonAlphanumeric;
};